module.exports = __webpack_public_path__ + "static/media/31JFA11.d5a65c38.jpg";